import * as React from "react";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";
import { Icons } from "src/library/components/Icon/types";
import { ITag } from "src/modules/product-tags/api/product-tags.api";

interface ProductTagProps extends ITag {
  showTooltip?: boolean;
}

/**
 *
 * Component to handle order additions
 */
const ProductTag: React.ReactFCWithChildren<ProductTagProps> = ({
  id, icon, iconCode, type, label, info, showTooltip
}) => {
  return (
    <>
      {showTooltip && (
        <Tooltip
          id={`product-tag-tooltip-${id}-${label}`}
          type="dark"
          place="right"
          getContent={() => {
            return (
              <>
                <Text color="white">
                  {label}
                </Text>

                {" "}

                {info && info.length && (
                  <Text color="white">
                    {` - ${info}`}
                  </Text>
                )}
              </>
            );
          }}
        />
      )}

      <ProductTagWrapper
        className="icon-wrapper"
        type={type}
        data-tip
        data-for={`product-tag-tooltip-${id}-${label}`}
      >
        {!!icon && (
          <Icon
            size={15}
            className="tag-icon"
            icon={icon.toLowerCase() as Icons}
            $fillColor="white"
          />
        )}

        {!!iconCode && !icon && (
          <Text
            weight="bold"
            className="tag-text"
            color="white"
          >
            {iconCode}
          </Text>
        )}
      </ProductTagWrapper>
    </>
  );
};

const ProductTagWrapper = styled.div<Pick<ProductTagProps, "type">>`
  ${({ theme, type }) => css`
    background: ${type === "Dietary & lifestyle" ? theme.colors.success : type === "Allergen" ? theme.colors.warn : theme.colors.midGrey};
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.borderRadius};

    .tag-text {
      font-size: 1em;
    }
  `}
`;

export default ProductTag;
